import axios from "axios";
import axiosInstance from "../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";

const getToken = () => {
    return localStorage.getItem("token");
};

export const SATDashboard = async (
    date,
    ZoneId,
    CircleId,
    WardId,
    TransferStationId,
    OwnerTypeId
) => {
    try {
        let apiUrl =
            API_BASE_URL1 +
            "DashboardReport/SATCountDashboard?";

        // Append StartDate and endDate
        if (date) {
            apiUrl += `Date=${date}`;
        }

        // Append ZoneId if not null
        if (ZoneId !== null) {
            apiUrl += `&ZoneId=${ZoneId}`;
        }

        // Append CircleId if not null
        if (CircleId !== null) {
            apiUrl += `&CircleId=${CircleId}`;
        }

        // Append WardId if not null
        if (WardId !== null) {
            apiUrl += `&WardId=${WardId}`;
        }

        // Append TransferStationId if not null
        if (TransferStationId !== null) {
            apiUrl += `&TransferStationId=${TransferStationId}`;
        }

        // Append OwnerTypeId if not null
        if (OwnerTypeId !== null) {
            apiUrl += `&OwnerTypeId=${OwnerTypeId}`;
        }

        const token = getToken(); // Get the token
        const response = await axiosInstance.get(apiUrl, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
};
